export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  desc?: string; // 描述
  link?: string; // 只需 pc
  pcLink?: string; // 需要多个下载 pc
  azLink?: string; // 需要多个下载 az
  iosLink?: string; // 需要多个下载 ios
  sendAplus?: boolean; // 需要发送(window as any).aplus_queue
  isRequest?: boolean; // 需要百度转化API上报
  isSougouJs?: boolean; // 需要发送搜狗js
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
  IDX?: number; // 类型1 代表360 不传则是百度 后面又其他的再新增类型
  key?: string; // 需要360上报api拼接
  Secret?: string; // 需要360上报api拼接
}

export const basePcList: BasePcList[] = [
  {
    id: "1",
    name: "360",
    path: "/360",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6032.exe",
    azLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    sendAplus: true,
  },
  {
    id: "2",
    name: "wb",
    path: "/wb",
    pcLink: "//static.dhsf.xqhuyu.com/temporary_file/1657778073000_wHhFp.exe",
    azLink: "/static/img/baseImg/download/wb_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
  },
  {
    id: "4",
    name: "sougou",
    path: "/sougou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6014.exe",
    azLink: "/static/img/baseImg/download/sougou_download_android.png",
    iosLink: "/static/img/baseImg/download/sougou_download_android.png",
  },
  {
    id: "5",
    name: "3601",
    path: "/3601",
    pcLink: "//static.dhsf.xqhuyu.com/temporary_file/1658812705000_3S6S5.exe",
    azLink: "/static/img/baseImg/download/3601_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
  },
  {
    id: "6",
    name: "2345",
    path: "/2345",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6029.exe",
  },
  {
    id: "7",
    name: "tieba",
    path: "/tieba",
    link: "//static.dhsf.996box.com/box/channel_app/boxSetup@6079.exe",
  },
  {
    id: "8",
    name: "xunyou",
    path: "/xunyou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1661762599000_ek2kX.exe",
    azLink: "/static/img/baseImg/download/xunyou_download_android.png",
  },
  {
    id: "9",
    name: "07073",
    path: "/07073",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6035.exe",
    azLink: "/static/img/baseImg/download/07073_download_android.png",
  },
  {
    id: "10",
    name: "yueke",
    path: "/yueke",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/1661763691000_jrxZs.exe",
  },
  {
    id: "11",
    name: "yx360",
    path: "/yx360",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1662456167000_y7Hsm.exe",
    azLink: "/static/img/baseImg/download/yx360_download_android.png",
  },
  {
    id: "12",
    name: "yx3602",
    path: "/yx3602",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1664271410000_jNNMH.exe",
    azLink: "/static/img/baseImg/download/yx3602_download_android.png",
  },
  {
    id: "13",
    name: "sw360",
    path: "/sw360",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/1666149756000_8KTdK.exe",
  },
  {
    id: "14",
    name: "xunlan",
    path: "/xunlan",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6043.exe",
    azLink: "/static/img/baseImg/download/xunlan_download_android.png",
  },
  {
    id: "15",
    name: "yueke1",
    path: "/yueke1",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6044.exe",
    isRequest: true,
  },
  {
    id: "17",
    name: "cnxh",
    path: "/cnxh",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6064.exe",
  },
  {
    id: "18",
    name: "baidu6",
    path: "/baidu6",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6067.exe",
  },
  {
    id: "19",
    name: "baidu7",
    path: "/baidu7",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6068.exe",
    isBaiduApiToken:
      "7ERIXG003auS3904Knf6b26XwRF3O8rH@3d3cPSSF3TUdpf5fqnCye4qWMjPdAVX2",
  },
  {
    id: "20",
    name: "lx",
    path: "/lx",
    link: "//static.dhsf.996box.com/box/channel_app/boxSetup@6081.exe",
  },
  {
    id: "21",
    name: "sougou4",
    path: "/sougou4",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6082.exe",
    isSougouJs: true,
  },
  {
    id: "22",
    name: "baidu13",
    path: "/baidu13",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6040.exe",
  },
  {
    id: "23",
    name: "baidu14",
    path: "/baidu14",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6085.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "NtElS6jQh7zHvUOLLpbUiTvWxcvGeot6@t7uit1ruIAMsEKKGMGaTIYengT32VCxa",
  },
  {
    id: "24",
    name: "by",
    path: "/by",
    link: "//static.dhsf.996box.com/box/channel_app/996box363SetupSigned@6109.exe",
  },
  {
    id: "25",
    name: "fb1",
    path: "/fb1",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521204@6087.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "TRixfpKwzuOPQtlL4f7O03mO4lRrrm17@w30YEWvRKYEGqNRppBS7lITCzpUygnA3",
  },
  {
    id: "26",
    name: "fb2",
    path: "/fb2",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521204@6087.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "7mnY4PCZMSKWHdk8DY6mfiIRWp94XaKw@B66bfBzYSLoj20o8kKrh5LrGr8cXu7RG",
  },
  {
    id: "27",
    name: "fb/gameDetail",
    path: "/fb/gameDetail",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521204@6087.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "7mnY4PCZMSKWHdk8DY6mfiIRWp94XaKw@B66bfBzYSLoj20o8kKrh5LrGr8cXu7RG",
  },
  {
    id: "28",
    name: "360sf1",
    path: "/360sf1",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6091.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "HRV1Fzkl14vgCtBxkcVANB8jNz0ULjcR@K2graNjvqgaqu9L9AEP5yQf1a3nm3AHE",
    IDX: 1,
    key: "rjplaws35dnidn6c6bvt",
    Secret: "0ycsi0vb7i7z5ajxef0giq6d4r4en6kl",
  },
  {
    id: "29",
    name: "360sf1/gameDetail",
    path: "/360sf1/gameDetail",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6091.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "HRV1Fzkl14vgCtBxkcVANB8jNz0ULjcR@K2graNjvqgaqu9L9AEP5yQf1a3nm3AHE",
    IDX: 1,
    key: "rjplaws35dnidn6c6bvt",
    Secret: "0ycsi0vb7i7z5ajxef0giq6d4r4en6kl",
  },
  {
    id: "30",
    name: "yuekebd2",
    path: "/yuekebd2",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6096.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "O1rOy1LfYhyTaLSUbx6jZGYQLln1Y3HG@fHSZLly8ZaFhXlv8fYZ5t7dd2ohEWfaR",
  },
  {
    id: "31",
    name: "yx3608",
    path: "/yx3608",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6095.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
  },
  {
    id: "32",
    name: "fs3601",
    path: "/fs3601",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6097.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
  },
  {
    id: "33",
    name: "fs3602",
    path: "/fs3602",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6098.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
  },
  {
    id: "34",
    name: "fs3603",
    path: "/fs3603",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6099.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
  },
  {
    id: "35",
    name: "fssg1",
    path: "/fssg1",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6101.exe",
  },
  {
    id: "36",
    name: "fsbd2",
    path: "/fsbd2",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6100.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "Q38jfbh5i1iKF09SBpsqwtfx1iGx5HpO@CuNTMCCA4LwDmBWiqCVAWM9tIP1VxKGa",
  },
  {
    id: "37",
    name: "biying",
    path: "/biying",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6112.exe",
  },
];
